import { render, staticRenderFns } from "./WarrantyFailsRegions.vue?vue&type=template&id=7fd87ac3"
import script from "./WarrantyFailsRegions.vue?vue&type=script&lang=js"
export * from "./WarrantyFailsRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports